import { ANNUAL_LEAVE_LIST, SET_PAGES } from "@/store/mutation-types";
import {
  ANNUAL_LEAVE_TYPE,
  convertObjectToParams,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  downloadFile,
  formatDateStringToString,
  formatDateToString,
  getInfoStaffFull,
  PAGE_DEFAULT,
} from "@/utils";
import moment from "moment";
import http from "../helpers/httpInterceptor";

const state = () => ({
  annualLeaveList: [],
  pages: PAGE_DEFAULT,
});

const mutations = {
  [ANNUAL_LEAVE_LIST](states, data) {
    states.annualLeaveList = formatData(data);
  },
  [SET_PAGES](state, data) {
    state.pages = data;
  },
};

const actions = {
  getAnnualLeaveList({ commit }, payload) {
    return http
      .get(`/tms/leaves-management${convertObjectToParams(payload)}`)
      .then((res) => {
        const {
          data,
          page: { page, size, total_element },
        } = res.data;
        commit(ANNUAL_LEAVE_LIST, data ?? []);
        commit(SET_PAGES, {
          page,
          size,
          total: total_element,
        });
        return res.data;
      })
      .catch((error) => {
        commit(ANNUAL_LEAVE_LIST, []);
        commit(SET_PAGES, PAGE_DEFAULT);
        throw error;
      });
  },
  exportAnnualLeaveList(_, payload) {
    return http
      .get(`/tms/excel/export-leave-fund${convertObjectToParams(payload)}`, { responseType: "blob" })
      .then((res) => {
        const { filename } = res.headers;
        downloadFile(res.data, filename ?? "LeaveFund.xlsx");
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
};

const formatData = (data) => {
  if (!data || data.length <= 0) return [];
  return data?.map((item) => {
    const {
      employee: { role },
      annual_leave,
      hired_date,
      timesheet_detail: { from_date, to_date },
    } = item;
    const annualLeaveList = Object.keys(ANNUAL_LEAVE_TYPE).map((type) => {
      return {
        annualLeaveType: ANNUAL_LEAVE_TYPE?.[type] ?? "",
        ...(annual_leave?.[type] ?? {}),
        key: type,
      };
    });
    return {
      ...item,
      ...item.annual_leave,
      unAllowedLeave:
        item?.month_leave_list?.filter((month) => month.totalLeave === 0).map((month) => `Tháng ${month.month}`) ?? [],
      fullName: getInfoStaffFull(item?.employee),
      role: role ?? "",
      seniorityDate: formatDateToString(hired_date, DATE_FORMAT_V2, DATE_FORMAT_V2_FULL),
      details: annualLeaveList ?? [],
      rangeTimesheet: `${moment(from_date).format(DATE_FORMAT_V2)} - ${formatDateStringToString(
        to_date,
        DATE_FORMAT_V2,
        DATE_FORMAT_SHORT
      )}`,
      ...(annual_leave?.total_leave_detail ?? {}),
    };
  });
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
